// ============================================================================
// CHAPITRE 4 : CRUCIFIXION ET RÉSURRECTION - Niveaux 40 à 52 COMPLET
// ============================================================================

export const chapter4CrucifixionResurrection = {
  id: 4,
  name: "Crucifixion et Résurrection",
  description: "Il est ressuscité !",
  icon: "✝️",
  levelRange: { start: 40, end: 52 },
  
  levels: {
    40: {
      name: "L'Arrestation",
      challenge: "Judas, c'est par un baiser que tu livres le Fils de l'homme ?",
      questions: {
        easy: {
          question: "Qui trahit Jésus ?",
          options: ["Pierre", "Judas", "Thomas", "Matthieu"],
          correct: 1,
          hint: "Un des douze disciples",
          funFact: "💔 Judas vendit Jésus pour 30 pièces d'argent - le prix d'un esclave!"
        },
        medium: {
          question: "Quel signe Judas utilisa-t-il pour identifier Jésus ?",
          options: [
            "Il le pointa du doigt",
            "Il l'appela par son nom",
            "Il lui donna un baiser",
            "Il le désigna aux soldats"
          ],
          correct: 2,
          hint: "Un geste d'affection détourné",
          funFact: "😢 Le baiser, symbole d'amour, devient instrument de trahison!"
        },
        hard: {
          question: "Comment Jésus réagit-il face à la trahison et à l'arrestation ?",
          options: [
            "Il se défend violemment",
            "Il fuit",
            "Il accepte avec dignité et guérit l'oreille du serviteur",
            "Il maudit ses ennemis"
          ],
          correct: 2,
          hint: "Il manifeste l'amour même envers ses ennemis",
          funFact: "✨ Même en étant arrêté, Jésus guérit l'oreille coupée de Malchus!"
        }
      }
    },
    
    41: {
      name: "Le Reniement de Pierre",
      challenge: "Avant que le coq chante, tu me renieras trois fois...",
      questions: {
        easy: {
          question: "Combien de fois Pierre renia-t-il Jésus ?",
          options: ["1 fois", "2 fois", "3 fois", "4 fois"],
          correct: 2,
          hint: "Le nombre que Jésus avait prédit",
          funFact: "🐓 Le chant du coq rappela à Pierre la prophétie de Jésus!"
        },
        medium: {
          question: "Où Pierre était-il quand il renia Jésus ?",
          options: [
            "Dans le Temple",
            "Chez Pilate",
            "Dans la cour du souverain sacrificateur",
            "Sur la route"
          ],
          correct: 2,
          hint: "Il suivait Jésus de loin",
          funFact: "🔥 Pierre se réchauffait près du feu avec les ennemis de Jésus!"
        },
        hard: {
          question: "Que nous enseigne la restauration de Pierre après son reniement ?",
          options: [
            "Certains péchés sont impardonnables",
            "L'amour de Jésus relève même nos plus grandes chutes",
            "Pierre était indigne",
            "Il faut cacher ses fautes"
          ],
          correct: 1,
          hint: "Il s'agit de la grâce qui restaure",
          funFact: "💝 Jésus demande 3 fois 'M'aimes-tu?' pour restaurer les 3 reniements!"
        }
      }
    },

    42: {
      name: "Jésus devant Pilate",
      challenge: "Es-tu le roi des Juifs ? Tu le dis...",
      questions: {
        easy: {
          question: "Qui était le gouverneur romain qui jugea Jésus ?",
          options: ["César", "Pilate", "Hérode", "Antoine"],
          correct: 1,
          hint: "Le représentant de Rome en Judée",
          funFact: "⚖️ Pilate reconnaît l'innocence de Jésus mais le condamne par lâcheté!"
        },
        medium: {
          question: "Quelle coutume Pilate proposa-t-il d'utiliser ?",
          options: [
            "Libérer un prisonnier à la Pâque",
            "Reporter le jugement",
            "Faire appel à César",
            "Exiler Jésus"
          ],
          correct: 0,
          hint: "Une tradition pascale",
          funFact: "🔓 Pilate espérait libérer Jésus grâce à cette coutume pascale!"
        },
        hard: {
          question: "Que révèle l'attitude de Pilate sur la justice humaine ?",
          options: [
            "La justice est toujours rendue",
            "La pression populaire peut corrompre même la justice",
            "Pilate était méchant",
            "La politique prime sur la vérité"
          ],
          correct: 1,
          hint: "Il s'agit de la faiblesse face à la foule",
          funFact: "💧 Pilate se lave les mains mais reste responsable de l'injustice!"
        }
      }
    },

    43: {
      name: "Barabbas ou Jésus",
      challenge: "Lequel voulez-vous que je vous relâche : Barabbas ou Jésus ?",
      questions: {
        easy: {
          question: "Qui la foule choisit-elle de libérer ?",
          options: ["Jésus", "Barabbas", "Pierre", "Jean"],
          correct: 1,
          hint: "Un brigand et meurtrier",
          funFact: "🔗 Barabbas signifie 'fils du père' - substitution symbolique!"
        },
        medium: {
          question: "Que cria la foule concernant Jésus ?",
          options: [
            "Libérez-le !",
            "Crucifie-le !",
            "Exilez-le !",
            "Emprisonnez-le !"
          ],
          correct: 1,
          hint: "Ils demandaient la peine capitale",
          funFact: "😱 La même foule qui criait 'Hosanna' crie maintenant 'Crucifie'!"
        },
        hard: {
          question: "Que symbolise le choix de Barabbas plutôt que Jésus ?",
          options: [
            "Une erreur de jugement",
            "L'humanité choisit souvent la violence plutôt que l'amour",
            "La liberté politique",
            "Une manipulation"
          ],
          correct: 1,
          hint: "Il s'agit d'un choix moral profond",
          funFact: "⚔️ Choisir Barabbas (violence) plutôt que Jésus (paix) révèle le cœur humain!"
        }
      }
    },

    44: {
      name: "La Flagellation et la Couronne d'Épines",
      challenge: "Salut, roi des Juifs ! Et ils le frappaient...",
      questions: {
        easy: {
          question: "De quoi les soldats firent-ils une couronne pour Jésus ?",
          options: ["D'or", "D'épines", "De laurier", "D'argent"],
          correct: 1,
          hint: "Quelque chose qui blesse",
          funFact: "👑 Couronne d'épines sur le Roi des rois - ironie tragique et prophétique!"
        },
        medium: {
          question: "De quelle couleur était le manteau qu'ils mirent sur Jésus ?",
          options: [
            "Bleu",
            "Pourpre (rouge royal)",
            "Blanc",
            "Noir"
          ],
          correct: 1,
          hint: "La couleur des rois",
          funFact: "🟣 Ils se moquaient de sa royauté sans savoir qu'Il est vraiment Roi!"
        },
        hard: {
          question: "Comment Jésus réagit-il aux moqueries et souffrances ?",
          options: [
            "Il se plaint",
            "Il maudit ses bourreaux",
            "Il endure dans le silence, accomplissant les prophéties",
            "Il appelle ses anges"
          ],
          correct: 2,
          hint: "Comme un agneau muet devant celui qui le tond",
          funFact: "🐑 'Il n'a pas ouvert la bouche' - Ésaïe 53 s'accomplit parfaitement!"
        }
      }
    },

    45: {
      name: "Le Chemin vers Golgotha",
      challenge: "Ils prirent Jésus et l'emmenèrent. Portant sa croix...",
      questions: {
        easy: {
          question: "Qui aida Jésus à porter sa croix ?",
          options: [
            "Jean",
            "Simon de Cyrène",
            "Joseph d'Arimathée",
            "Nicodème"
          ],
          correct: 1,
          hint: "Un homme de Cyrène requis par les soldats",
          funFact: "🚶 Simon devient malgré lui disciple en portant la croix avec Jésus!"
        },
        medium: {
          question: "Que dit Jésus aux femmes qui pleuraient ?",
          options: [
            "Consolez-vous",
            "Ne pleurez pas sur moi mais sur vos enfants",
            "Suivez-moi",
            "Priez pour moi"
          ],
          correct: 1,
          hint: "Il pense aux futures souffrances de Jérusalem",
          funFact: "😢 Même en souffrant, Jésus pense aux autres et prophétise!"
        },
        hard: {
          question: "Que symbolise le fait que Jésus porte sa propre croix ?",
          options: [
            "La tradition romaine",
            "Il assume volontairement nos péchés",
            "Une humiliation supplémentaire",
            "La faiblesse humaine"
          ],
          correct: 1,
          hint: "Il s'agit de l'acceptation volontaire du sacrifice",
          funFact: "✝️ Porter sa croix : Jésus assume volontairement le poids de nos fautes!"
        }
      }
    },

    46: {
      name: "La Crucifixion",
      challenge: "Père, pardonne-leur, car ils ne savent ce qu'ils font...",
      questions: {
        easy: {
          question: "Entre qui Jésus fut-il crucifié ?",
          options: [
            "Deux soldats",
            "Deux brigands",
            "Deux disciples",
            "Deux prêtres"
          ],
          correct: 1,
          hint: "Deux criminels",
          funFact: "⚖️ Jésus entre deux brigands - l'innocent avec les coupables!"
        },
        medium: {
          question: "Quelle inscription Pilate fit-il mettre sur la croix ?",
          options: [
            "Jésus de Nazareth",
            "Le roi des Juifs",
            "Jésus de Nazareth, Roi des Juifs",
            "Le fils de Dieu"
          ],
          correct: 2,
          hint: "En hébreu, grec et latin",
          funFact: "📜 INRI : Proclamation involontaire de la royauté universelle de Jésus!"
        },
        hard: {
          question: "Que révèlent les sept paroles de Jésus sur la croix ?",
          options: [
            "Sa souffrance physique seulement",
            "Son amour parfait : pardon, salut, amour filial, mission accomplie",
            "Sa colère",
            "Son désespoir"
          ],
          correct: 1,
          hint: "Il s'agit de l'amour qui triomphe même dans la mort",
          funFact: "💝 Sept paroles d'amour parfait : pardon, promesse, tendresse, abandon, soif, accomplissement, confiance!"
        }
      }
    },

    47: {
      name: "La Mort de Jésus",
      challenge: "Tout est accompli ! Et, baissant la tête, il rendit l'esprit...",
      questions: {
        easy: {
          question: "Que se déchira dans le Temple quand Jésus mourut ?",
          options: [
            "La porte",
            "Le voile du lieu très saint",
            "L'autel",
            "Les colonnes"
          ],
          correct: 1,
          hint: "Ce qui séparait le lieu très saint",
          funFact: "⛪ Le voile déchiré ouvre l'accès direct à Dieu pour tous!"
        },
        medium: {
          question: "Que dit le centurion romain après la mort de Jésus ?",
          options: [
            "Il était innocent",
            "Vraiment, cet homme était Fils de Dieu",
            "C'était un grand homme",
            "Justice est faite"
          ],
          correct: 1,
          hint: "Une reconnaissance de la divinité",
          funFact: "🎖️ Un soldat païen reconnaît ce que les religieux ont refusé!"
        },
        hard: {
          question: "Que signifie 'Tout est accompli' sur la croix ?",
          options: [
            "Sa vie se termine",
            "La mission de salut est parfaitement achevée",
            "Il abandonne",
            "Il exprime sa douleur"
          ],
          correct: 1,
          hint: "Il s'agit de l'accomplissement parfait du plan divin",
          funFact: "✅ 'Tetelestai' = 'Payé intégralement' - notre dette de péché est soldée!"
        }
      }
    },

    48: {
      name: "L'Ensevelissement",
      challenge: "Joseph d'Arimathée... demanda le corps de Jésus...",
      questions: {
        easy: {
          question: "Qui demanda le corps de Jésus à Pilate ?",
          options: [
            "Jean",
            "Joseph d'Arimathée",
            "Nicodème",
            "Marie Madeleine"
          ],
          correct: 1,
          hint: "Un membre secret du sanhédrin",
          funFact: "🤫 Joseph d'Arimathée sort de l'ombre pour honorer Jésus mort!"
        },
        medium: {
          question: "Où Jésus fut-il enseveli ?",
          options: [
            "Dans le cimetière public",
            "Dans un tombeau neuf taillé dans le roc",
            "Dans une fosse commune",
            "Au mont des Oliviers"
          ],
          correct: 1,
          hint: "Un tombeau où personne n'avait été mis",
          funFact: "🪦 Tombeau neuf pour le Nouvel Adam - aucune autre mort ne l'a souillé!"
        },
        hard: {
          question: "Pourquoi l'ensevelissement de Jésus était-il important ?",
          options: [
            "Pour respecter la tradition",
            "Pour prouver sa mort réelle avant la résurrection",
            "Pour honorer sa famille",
            "Pour éviter les troubles"
          ],
          correct: 1,
          hint: "Il s'agit de confirmer la réalité de sa mort",
          funFact: "⚱️ Mort réelle + ensevelissement = résurrection authentique et miraculeuse!"
        }
      }
    },

    49: {
      name: "Le Tombeau Vide",
      challenge: "Pourquoi cherchez-vous parmi les morts celui qui est vivant ?",
      questions: {
        easy: {
          question: "Qui découvrit en premier le tombeau vide ?",
          options: [
            "Pierre",
            "Jean",
            "Marie Madeleine et les femmes",
            "Joseph d'Arimathée"
          ],
          correct: 2,
          hint: "Les femmes qui venaient embaumer le corps",
          funFact: "👩 Les femmes, témoins fidèles, sont les premières à annoncer la résurrection!"
        },
        medium: {
          question: "Qu'y avait-il dans le tombeau vide ?",
          options: [
            "Rien du tout",
            "Les linges pliés à leur place",
            "Des fleurs",
            "Un message écrit"
          ],
          correct: 1,
          hint: "Les tissus mortuaires restés en place",
          funFact: "👻 Linges intacts : Jésus est passé au travers - corps glorifié!"
        },
        hard: {
          question: "Pourquoi le tombeau vide est-il crucial pour la foi chrétienne ?",
          options: [
            "C'est juste symbolique",
            "Il prouve la résurrection corporelle, victoire sur la mort",
            "Il évite le culte des reliques",
            "Il impressionne les gens"
          ],
          correct: 1,
          hint: "Il s'agit de la preuve de la victoire sur la mort",
          funFact: "🏆 Tombeau vide = victoire définitive sur la mort et l'enfer!"
        }
      }
    },

    50: {
      name: "Jésus Apparaît à Marie Madeleine",
      challenge: "Marie ! ... Rabbouni ! (c'est-à-dire Maître !)",
      questions: {
        easy: {
          question: "À qui Jésus apparut-il en premier après sa résurrection ?",
          options: [
            "À Pierre",
            "À Jean",
            "À Marie Madeleine",
            "Aux douze ensemble"
          ],
          correct: 2,
          hint: "Celle qui pleura au tombeau",
          funFact: "💖 Marie Madeleine devient 'apôtre des apôtres' - première messagère!"
        },
        medium: {
          question: "Pourquoi Marie ne reconnut-elle pas Jésus au début ?",
          options: [
            "Il faisait sombre",
            "Elle avait les yeux pleins de larmes",
            "Son corps glorifié était transformé",
            "Elle ne s'attendait pas à le voir"
          ],
          correct: 2,
          hint: "Il s'agit de la transformation du corps ressuscité",
          funFact: "✨ Corps glorifié : même Jésus mais transfiguré par la résurrection!"
        },
        hard: {
          question: "Que symbolise le fait que Jésus appelle Marie par son nom ?",
          options: [
            "Sa bonne mémoire",
            "L'amour personnel de Jésus pour chaque âme",
            "Une simple reconnaissance",
            "L'habitude"
          ],
          correct: 1,
          hint: "Il s'agit de la relation personnelle avec le Berger",
          funFact: "🐑 'Mes brebis entendent ma voix' - Jésus connaît chacun personnellement!"
        }
      }
    },

    51: {
      name: "Sur le Chemin d'Emmaüs",
      challenge: "Leurs yeux s'ouvrirent et ils le reconnurent à la fraction du pain...",
      questions: {
        easy: {
          question: "Combien de disciples marchaient vers Emmaüs ?",
          options: ["1", "2", "3", "4"],
          correct: 1,
          hint: "Cléopas et un compagnon",
          funFact: "👥 Deux disciples découragés deviennent témoins joyeux de la résurrection!"
        },
        medium: {
          question: "À quel moment reconnurent-ils Jésus ?",
          options: [
            "À sa voix",
            "À sa manière de marcher",
            "À la fraction du pain",
            "À ses cicatrices"
          ],
          correct: 2,
          hint: "Un geste eucharistique",
          funFact: "🍞 La communion révèle le Christ ressuscité - présence réelle!"
        },
        hard: {
          question: "Comment cette apparition nous enseigne-t-elle sur la présence de Jésus ?",
          options: [
            "Il apparaît seulement aux saints",
            "Il accompagne nos découragements et se révèle dans la Parole et le pain",
            "Il faut le chercher dans les lieux saints",
            "Il ne vient que si on le mérite"
          ],
          correct: 1,
          hint: "Il s'agit de sa présence dans l'ordinaire de nos vies",
          funFact: "🚶 Jésus marche avec nous dans nos découragements et transforme nos cœurs!"
        }
      }
    },

    52: {
      name: "L'Apparition aux Disciples",
      challenge: "La paix soit avec vous ! Comme le Père m'a envoyé, moi aussi je vous envoie...",
      questions: {
        easy: {
          question: "Quelle fut la première parole de Jésus aux disciples réunis ?",
          options: [
            "Bonjour !",
            "La paix soit avec vous !",
            "N'ayez pas peur !",
            "Réjouissez-vous !"
          ],
          correct: 1,
          hint: "Un salut de réconciliation",
          funFact: "☮️ 'Shalom' - Jésus apporte sa paix après leur abandon et peur!"
        },
        medium: {
          question: "Que donna Jésus aux disciples en soufflant sur eux ?",
          options: [
            "Sa bénédiction",
            "Le Saint-Esprit",
            "Des dons spirituels",
            "Sa paix"
          ],
          correct: 1,
          hint: "Le souffle de vie divine",
          funFact: "💨 Comme Dieu insuffla la vie à Adam, Jésus donne l'Esprit Saint!"
        },
        hard: {
          question: "Quel mandat Jésus confie-t-il aux disciples ?",
          options: [
            "Rester cachés",
            "Construire des églises",
            "Être envoyés dans le monde entier pour le salut",
            "Étudier les Écritures"
          ],
          correct: 2,
          hint: "Il s'agit de la Grande Commission",
          funFact: "🌍 De disciples craintifs, ils deviennent apôtres conquérants du monde entier!"
        }
      }
    }
  }
};